export default function DownloadDesignIcon() {
  return (
    <svg viewBox="0 0 14.23 13.75" xmlns="https://www.w3.org/2000/svg">
      <path d="M14.07 13.75H.16a.16.16 0 0 1-.16-.16v-1.2a.16.16 0 0 1 .16-.16h13.91a.16.16 0 0 1 .16.16v1.2a.16.16 0 0 1-.16.16zm-6.95-3.67h-.07L7 10 4.75 7.18a.16.16 0 0 1 0-.22.13.13 0 0 1 .1 0h1.51V.16A.16.16 0 0 1 6.51 0h1.21a.16.16 0 0 1 .16.16v6.77h1.48A.14.14 0 0 1 9.5 7a.15.15 0 0 1 0 .17L7.24 10z" />
    </svg>
  );
}
